module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"camera":"Камера","cameras":"Камеры","main":"Основное","tracks":"Треки","rtsp":"Видеопоток","video-archive":"Видеоархив","road":"Данные по состоянию дорожного полотна","air":"Данные по состоянию воздуха"},"en":{"camera":"Camera","cameras":"Cameras","main":"Main","tracks":"Tracks","rtsp":"Video","video-archive":"Video archive","road":"Road surface data","air":"Air data"}}')
  delete Component.options._Ctor
}
